<template>
  <v-card class="pa-2 stage-level-detail" tile flat>
    <div class="caption mb-3">
      {{ `${observatory.lat},${observatory.lng}` }}
    </div>

    <ManholeChart
      v-if="isRunning"
      :height="isMobile ? 200 : 250"
      :observatory="observatory"
      :timeSeries="timeSeries"
    />
    <v-card
      class="d-flex align-center justify-end mt-2"
      flat
      v-if="currentLevel !== null"
    >
      <v-card width="30" height="18" color="#3D8AFF"></v-card>
      <div class="caption ml-4">現在水位 {{ currentLevel }} m</div>
    </v-card>
    <v-card v-if="!isRunning" tile flat height="140">
      この観測所は、休止もしくは欠測しています。
    </v-card>

    <v-simple-table
      dense
      fixed-header
      height="calc(100dvh - 390px)"
      class="mt-3"
      v-if="isRunning"
    >
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">日時</th>
            <th class="text-left" v-if="false">状況</th>
            <th class="text-left">水位(m)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ts, i) in rows" :key="i">
            <td>{{ ts.time }}</td>
            <td v-if="false">{{ ts.status }}</td>
            <td>{{ ts.level }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import moment from "moment";
import ManholeChart from "./ManholeChart";
import * as common from "../../../utils/common";

export default {
  name: "PumpDetail",

  components: {
    ManholeChart
  },

  data() {
    return {};
  },

  computed: {
    isMobile() {
      return this.$route.path === "/mobile";
    },
    observatory() {
      return this.$store.getters.selectedObservatory;
    },
    isRunning() {
      return this.rows.length > 0;
    },
    baseDate() {
      return this.$store.getters.baseDate;
    },
    currentLevel() {
      const levels = this.timeSeries
        .map(r => r.level)
        .filter(l => l !== undefined);
      if (levels.length === 0) {
        return null;
      } else {
        return levels[levels.length - 1].toFixed(2);
      }
    },
    timeSeries() {
      if (this.observatory.timeSeries === undefined) {
        return [];
      } else {
        return this.observatory.timeSeries;
      }
    },
    rows() {
      return this.timeSeries
        .map(r => {
          const time = moment
            .utc(r.date, "YYYYMMDDHHmm")
            .local()
            .format("MM/DD HH:mm");
          return {
            time: time,
            status: common.getPumpStatusText(r.status),
            level:
              r.level !== undefined ? parseFloat(r.level).toFixed(2) : "---"
          };
        })
        .slice()
        .reverse();
    }
  }
};
</script>

<style lang="scss" scoped>
.stage-level-detail {
  tbody td {
    background: #eee;
  }
  tbody tr:nth-child(odd) td {
    background: #fff;
  }
}
</style>

<style lang="scss">
.stage-level-detail {
  .v-data-table__wrapper {
    overflow-y: auto !important;
  }
}
</style>
